export default (state = [], action) => {
  switch (action.type) {
    case "CREATE_SOBER_LIVING":
      return [...state, action.payload.soberLiving];
    case "UPDATE_SOBER_LIVINGS":
      return action.payload.soberLivings;
    case "DELETE_SOBER_LIVING":
      return state.filter((soberLiving) => {
        return soberLiving.id !== action.payload.soberLiving.id
      });
    default:
      return state;
  }
}
